(() => {
  const SELECTOR = '[data-ks-root]';
  const MOBILE_QUERY = '(max-width: 989px)';
  const registry = window.KennzeichenShop || (window.KennzeichenShop = {
    controllers: new WeakMap(),
    eventsBound: false
  });

  const COUNTRY_ALIASES = new Map([
    ['united states', 'united states'],
    ['united states of america', 'united states'],
    ['usa', 'united states'],
    ['us', 'united states'],
    ['amerika', 'united states'],
    ['vereinigte staaten', 'united states'],
    ['canada', 'canada'],
    ['kanada', 'canada'],
    ['mexico', 'mexico'],
    ['mexiko', 'mexico'],
    ['australia', 'australia'],
    ['australien', 'australia'],
    ['germany', 'deutschland'],
    ['deutschland', 'deutschland'],
    ['france', 'frankreich'],
    ['frankreich', 'frankreich'],
    ['italy', 'italien'],
    ['italien', 'italien'],
    ['spain', 'spanien'],
    ['spanien', 'spanien'],
    ['united kingdom', 'vereinigtes konigreich'],
    ['vereinigtes konigreich', 'vereinigtes konigreich'],
    ['uk', 'vereinigtes konigreich'],
    ['brazil', 'brasilien'],
    ['brasilien', 'brasilien'],
    ['japan', 'japan'],
    ['japon', 'japan'],
    ['etats-unis', 'united states'],
    ['états-unis', 'united states'],
    ['mexique', 'mexico'],
    ['australie', 'australia'],
    ['saint-martin', 'st. maarten']
  ]);

  const VEHICLE_ALIASES = new Map([
    ['auto', 'auto'],
    ['autos', 'auto'],
    ['pkw', 'auto'],
    ['car', 'auto'],
    ['cars', 'auto'],
    ['automobil', 'auto'],
    ['motorrad', 'motorrad'],
    ['motorrader', 'motorrad'],
    ['motorbike', 'motorrad'],
    ['motorcycle', 'motorrad'],
    ['bike', 'motorrad'],
    ['moto', 'motorrad'],
    ['voiture', 'auto']
  ]);

  const SPECIAL_USA_REGIONS = new Set(['guam', 'puerto rico', 'american samoa', 'virgin islands', 'washington d.c.', 'washington dc']);
  const SPECIAL_ALIASES = new Map([
    ['us regierung', 'us government'],
    ['u.s. regierung', 'us government'],
    ['offentlicher dienst', 'us government'],
    ['oeffentlicher dienst', 'us government'],
    ['offentlicher dienst usa', 'us government'],
    ['public service', 'us government'],
    ['us government', 'us government'],
    ['u.s. government', 'us government'],
    ['government service', 'us government'],
    ['service public', 'us government'],
    ['historische fahrzeuge', 'historic vehicles'],
    ['historisches fahrzeug', 'historic vehicles'],
    ['historische fahrzeug', 'historic vehicles'],
    ['historisches kennzeichen', 'historic vehicles'],
    ['oldtimer', 'historic vehicles'],
    ['historic vehicle', 'historic vehicles'],
    ['historic vehicles', 'historic vehicles'],
    ['historical vehicle', 'historic vehicles'],
    ['historical vehicles', 'historic vehicles'],
    ['vehicule historique', 'historic vehicles'],
    ['vehicules historiques', 'historic vehicles'],
    ['indianer', 'native american'],
    ['native american', 'native american'],
    ['amerindien', 'native american'],
    ['autochtone americain', 'native american']
  ]);

  function formatMessage(template, replacements = {}) {
    return Object.entries(replacements).reduce((text, [key, value]) => text.split(`__${key.toUpperCase()}__`).join(String(value)), String(template || ''));
  }

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase(document.documentElement.lang || 'de')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00a0\u202f]/g, ' ')
      .replace(/[\[\]"']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function canonicalCountry(value) {
    const normalized = normalize(value);
    return COUNTRY_ALIASES.get(normalized) || normalized;
  }


  function canonicalVehicle(value) {
    const normalized = normalize(value);
    return VEHICLE_ALIASES.get(normalized) || normalized;
  }

  function canonicalSpecial(value) {
    const normalized = normalize(value)
      .replace(/[_/–—-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (SPECIAL_ALIASES.has(normalized)) {
      return SPECIAL_ALIASES.get(normalized);
    }

    if (normalized.includes('histor') || normalized.includes('oldtimer')) {
      return 'historic vehicles';
    }

    if (
      normalized.includes('us regierung')
      || normalized.includes('offentlicher dienst')
      || normalized.includes('oeffentlicher dienst')
      || normalized.includes('public service')
      || normalized.includes('us government')
    ) {
      return 'us government';
    }

    return normalized;
  }

  function splitValues(value) {
    return String(value || '')
      .split(/[,;|]+/)
      .map((item) => normalize(item))
      .filter(Boolean);
  }

  function matchesField(rawValue, wantedValue, kind = 'text') {
    if (!wantedValue) return true;

    const canonicalize = kind === 'country'
      ? canonicalCountry
      : kind === 'vehicle'
        ? canonicalVehicle
        : kind === 'special'
          ? canonicalSpecial
          : normalize;

    const wanted = canonicalize(wantedValue);
    const values = splitValues(rawValue);
    if (!values.length) return false;
    return values.some((value) => canonicalize(value) === wanted);
  }

  function getFocusable(container) {
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((element) => element.offsetParent !== null);
  }

  function syncSearchInputs(value) {
    document.querySelectorAll('[data-ks-catalog-search]').forEach((input) => {
      if (input.value !== value) input.value = value;
    });
  }

  function closeHeaderSearch() {
    document.querySelectorAll('[data-header-search].is-open').forEach((search) => {
      search.classList.remove('is-open');
      search.querySelector('[data-header-search-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }

  function shuffleGrid(grid) {
    if (!grid || grid.dataset.ksRandomOrder !== 'true') return;
    const items = Array.from(grid.children);
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    const fragment = document.createDocumentFragment();
    items.forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
  }

  function showStatus(
    root,
    message,
    isError = false
  ) {
    const status = root.querySelector(
      '[data-ks-status]'
    );

    if (!status) return;

    status.textContent = message;
    status.dataset.error = String(isError);

    status.classList.add('is-visible');
    root.classList.add('is-status-visible');

    window.clearTimeout(status._hideTimer);

    status._hideTimer = window.setTimeout(() => {
      status.classList.remove('is-visible');
      root.classList.remove('is-status-visible');
    }, 3200);
  }

  async function quickAdd(event, root) {
    const form = event.target.closest('.ks-card__form');
    if (!form || !window.fetch || !window.FormData) return;

    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    if (!button || button.disabled) return;

    const originalLabel = button.getAttribute('aria-label');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const routesRoot = window.Shopify?.routes?.root || '/';
/*
*      const response = await fetch(`${routesRoot}cart/add.js`, {
*        method: 'POST',
*        headers: { Accept: 'application/json' },
*        body: new FormData(form)
*     });
*/

    const formData = new FormData(form);

    /*
    * Reservierung für 20 Minuten.
    * Der Wert wird als versteckte Line-Item-Property
    * im Shopify-Warenkorb gespeichert.
    */
    const reservationMinutes = 20;
    const reservedUntil = Date.now() + reservationMinutes * 60 * 1000;

    formData.set(
      'properties[_reserved_until]',
      String(reservedUntil)
    );

    const response = await fetch(`${routesRoot}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });

      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || root.dataset.ksI18nAddError || 'Product could not be added.');

      const cartResponse = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      
      const card = form.closest(
  '[data-ks-product-card]'
);

const state = String(
  card?.dataset.ksState || ''
).trim();

const plateNumber = String(
  card?.dataset.ksNumber ||
  card?.querySelector('.ks-card__title')
    ?.textContent ||
  payload.product_title ||
  'Produkt'
).trim();

const productLabel = state
  ? `${state} – ${plateNumber}`
  : plateNumber;

showStatus(
  root,
  formatMessage(
    root.dataset.ksI18nAdded ||
      '__PRODUCT__ wurde zum Warenkorb hinzugefügt.',
    {
      product: productLabel
    }
  )
);

    } catch (error) {
      showStatus(root, error.message || root.dataset.ksI18nGenericError || 'An error occurred.', true);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (originalLabel) button.setAttribute('aria-label', originalLabel);
    }
  }

  function createCatalogController(root) {
    const groups = Array.from(root.querySelectorAll('[data-ks-nav-group]'));
    const entries = Array.from(root.querySelectorAll('[data-ks-nav-entry]'));
    const filterLinks = Array.from(root.querySelectorAll('[data-ks-filter-link]'));
    const grid = root.querySelector('[data-ks-products-grid]');
    const cards = Array.from(root.querySelectorAll('[data-ks-product-card]'));
    const cardIndex = new WeakMap();
    const knownProductIds = new Set(
      cards
        .map((card) => String(card.dataset.ksProductId || '').trim())
        .filter(Boolean)
    );
    const lazySentinel = root.querySelector(
      '[data-ks-lazy-sentinel]'
    );
    const sectionId = String(root.dataset.ksSectionId || '').trim();
    const pageParam = String(root.dataset.ksPageParam || 'page').trim() || 'page';
    let currentPage = Math.max(1, Number.parseInt(root.dataset.ksCurrentPage || '1', 10));
    const totalPages = Math.max(currentPage, Number.parseInt(root.dataset.ksTotalPages || String(currentPage), 10));
    let nextPageUrl = String(root.dataset.ksNextPageUrl || '').trim();
    let catalogLoading = Boolean(nextPageUrl || currentPage < totalPages);
    let catalogLoadFailed = false;
    let catalogLoadPromise = null;
    let destroyed = false;
    const catalogAbortController = typeof AbortController === 'function'
      ? new AbortController()
      : null;

    const initialVisible = Math.max(
      1,
      Number.parseInt(root.dataset.ksLazyInitial || '10', 10)
    );

    const lazyBatchSize = Math.max(
      1,
      Number.parseInt(root.dataset.ksLazyBatch || '10', 10)
    );

    let visibleLimit = initialVisible;
    let currentMatchingCards = [];
    const empty = root.querySelector('[data-ks-search-empty]');
    const productsSection = root.querySelector('.ks-products');
    const heading = root.querySelector('[data-ks-products-heading]');
    const count = root.querySelector('[data-ks-products-count]');
    const resetButtons = Array.from(root.querySelectorAll('[data-ks-reset-toggle]'));
    const baseHeading = heading?.dataset.ksBaseHeading || heading?.textContent?.trim() || 'Produkte';
    const filters = { query: '', country: '', state: '', vehicle: '', special: '', label: '' };
    const i18n = {
      available: root.dataset.ksI18nAvailable || '__COUNT__ available',
      productOne: root.dataset.ksI18nProductOne || 'Product',
      productOther: root.dataset.ksI18nProductOther || 'Products',
      searchResults: root.dataset.ksI18nSearchResults || 'Search results for __VALUE__',
      specialResults: root.dataset.ksI18nSpecialResults || 'Special US license plates',
      specialNamedResults: root.dataset.ksI18nSpecialNamedResults || '__VALUE__ license plates',
      stateResults: root.dataset.ksI18nStateResults || '__VALUE__ license plates',
      countryResults: root.dataset.ksI18nCountryResults || 'License plates from __VALUE__',
      vehicleResults: root.dataset.ksI18nVehicleResults || '__VALUE__ license plates',
      catalogLoading: root.dataset.ksI18nCatalogLoading || 'More products are loading …',
      catalogLoadError: root.dataset.ksI18nCatalogLoadError || 'Part of the catalog could not be loaded. Please reload the page.'
    };

    let queryTimer = 0;
    let lastCatalogProgressUpdate = 0;

    function uniqueCanonicalValues(rawValue, canonicalize = normalize) {
      return [...new Set(splitValues(rawValue).map(canonicalize).filter(Boolean))];
    }

    function indexCard(card) {
      const indexed = {
        search: normalize(card.dataset.ksSearchText),
        countries: uniqueCanonicalValues(card.dataset.ksCountry, canonicalCountry),
        states: uniqueCanonicalValues(card.dataset.ksState, normalize),
        vehicles: uniqueCanonicalValues(card.dataset.ksVehicle, canonicalVehicle),
        specials: uniqueCanonicalValues(card.dataset.ksSpecial, canonicalSpecial),
        hasSpecial: normalize(card.dataset.ksSpecial) !== ''
      };

      cardIndex.set(card, indexed);
      return indexed;
    }

    function getCardIndex(card) {
      return cardIndex.get(card) || indexCard(card);
    }

    cards.forEach(indexCard);

    function yieldToBrowser() {
      return new Promise((resolve) => {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(() => resolve(), { timeout: 140 });
        } else {
          window.setTimeout(resolve, 0);
        }
      });
    }

    function hasActiveFilter() {
      return Boolean(filters.query || filters.country || filters.state || filters.vehicle || filters.special);
    }

    function cardMatches(card) {
      const indexed = getCardIndex(card);
      const wantedState = normalize(filters.state);
      const wantedVehicle = canonicalVehicle(filters.vehicle);
      const wantedSpecial = canonicalSpecial(filters.special);
      const wantedCountry = canonicalCountry(filters.country);

      const searchMatches = !filters.query || indexed.search.includes(filters.query);
      const stateMatches = !filters.state || indexed.states.includes(wantedState);
      const vehicleMatches = !filters.vehicle || indexed.vehicles.includes(wantedVehicle);
      const specialMatches = !filters.special
        || (
          filters.special === '*'
            ? indexed.hasSpecial
            : filters.special === '__all_usa_special__'
              ? indexed.hasSpecial || indexed.states.some((state) => SPECIAL_USA_REGIONS.has(state))
              : indexed.specials.includes(wantedSpecial)
        );

      let countryMatches = true;
      if (filters.country) {
        countryMatches = indexed.countries.includes(wantedCountry);

        // Bei einem konkreten Bundesstaat darf ein altes/leeres Länder-Metafeld den Treffer nicht blockieren.
        if ((filters.state || filters.special) && indexed.countries.length === 0) {
          countryMatches = true;
        }
      }

      return searchMatches && countryMatches && stateMatches && vehicleMatches && specialMatches;
    }

    function linkMatchesCard(link, card) {
      const country = String(link.dataset.ksFilterCountry || '').trim();
      const state = String(link.dataset.ksFilterState || '').trim();
      const vehicle = String(link.dataset.ksFilterVehicle || '').trim();
      const special = String(link.dataset.ksFilterSpecial || '').trim();
      const indexed = getCardIndex(card);

      const stateMatches = !state || indexed.states.includes(normalize(state));
      const vehicleMatches = !vehicle || indexed.vehicles.includes(canonicalVehicle(vehicle));
      const specialMatches = !special
        || (
          special === '*'
            ? indexed.hasSpecial
            : special === '__all_usa_special__'
              ? indexed.hasSpecial || indexed.states.some((entryState) => SPECIAL_USA_REGIONS.has(entryState))
              : indexed.specials.includes(canonicalSpecial(special))
        );

      let countryMatches = true;
      if (country) {
        countryMatches = indexed.countries.includes(canonicalCountry(country));
        if ((state || special) && indexed.countries.length === 0) {
          countryMatches = true;
        }
      }

      return countryMatches && stateMatches && vehicleMatches && specialMatches;
    }

    function updateAvailableCounts() {
      filterLinks.forEach((link) => {
        const countElement = link.querySelector('[data-ks-nav-count]');
        if (!countElement) return;

        const available = cards.reduce((total, card) => total + (linkMatchesCard(link, card) ? 1 : 0), 0);
        countElement.textContent = `(${available})`;
        countElement.setAttribute('aria-label', formatMessage(i18n.available, { count: available }));
        link.classList.toggle('is-empty', available === 0);
      });
    }

    function syncGroupToggle(group) {
      const expanded = group.dataset.ksNavExpanded === 'true';
      const button = group.querySelector('[data-ks-nav-toggle]');
      const label = button?.querySelector('[data-ks-nav-toggle-label]');
      if (!button) return;

      button.setAttribute('aria-expanded', String(expanded));
      group.classList.toggle('is-expanded', expanded);
      if (label) {
        label.textContent = expanded
          ? button.dataset.labelHide || 'Weniger anzeigen'
          : button.dataset.labelShow || 'Alle anzeigen';
      }
    }

    function updateNavigationSearch() {
      const query = filters.query;

      groups.forEach((group) => {
        const expanded = group.dataset.ksNavExpanded === 'true';
        const groupText = normalize(group.dataset.ksNavSearch);
        const groupMatch = query !== '' && groupText.includes(query);
        const groupEntries = Array.from(group.querySelectorAll('[data-ks-nav-entry]'));
        const moreRow = group.querySelector('[data-ks-nav-more-row]');
        let childMatches = 0;

        groupEntries.forEach((entry) => {
          const searchMatches = query === '' || groupMatch || normalize(entry.dataset.ksNavSearch).includes(query);
          const isCollapsible = entry.hasAttribute('data-ks-nav-collapsible');

          if (query !== '') {
            entry.hidden = !searchMatches;
          } else {
            entry.hidden = isCollapsible && !expanded;
          }

          if (searchMatches) childMatches += 1;
        });

        group.hidden = query !== '' && !groupMatch && childMatches === 0;
        if (moreRow) moreRow.hidden = query !== '';
        if (query !== '' && !group.hidden) group.querySelector('details')?.setAttribute('open', '');
        syncGroupToggle(group);
      });
    }

    function updateActiveNavigation() {
      filterLinks.forEach((link) => {
        const linkCountry = canonicalCountry(link.dataset.ksFilterCountry);
        const linkState = normalize(link.dataset.ksFilterState);
        const linkVehicle = canonicalVehicle(link.dataset.ksFilterVehicle);
        const linkSpecial = String(link.dataset.ksFilterSpecial || '').trim();
        let active = false;

        if (linkSpecial) {
          active = linkSpecial === '*'
            ? filters.special === '*'
            : canonicalSpecial(linkSpecial) === canonicalSpecial(filters.special);
        } else if (linkState) {
          active = linkState === normalize(filters.state);
        } else if (linkVehicle) {
          active = linkVehicle === canonicalVehicle(filters.vehicle);
        } else if (linkCountry) {
          active = !filters.state && !filters.special && linkCountry === canonicalCountry(filters.country);
        }

        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'true');
          link.closest('details')?.setAttribute('open', '');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function updateHeading(totalMatches, shownCount) {
      if (!heading) return;

      if (filters.query) {
        heading.textContent = formatMessage(i18n.searchResults, { value: filters.label || filters.query });
      } else if (filters.special) {
        heading.textContent = filters.special === '*' || filters.special === '__all_usa_special__'
          ? i18n.specialResults
          : formatMessage(i18n.specialNamedResults, { value: filters.label || filters.special });
      } else if (filters.state) {
        heading.textContent = formatMessage(i18n.stateResults, { value: filters.label || filters.state });
      } else if (filters.country) {
        heading.textContent = formatMessage(i18n.countryResults, { value: filters.label || filters.country });
      } else if (filters.vehicle) {
        heading.textContent = formatMessage(i18n.vehicleResults, { value: filters.label || filters.vehicle });
      } else {
        heading.textContent = baseHeading;
      }

      if (count) {
      const productLabel =
        totalMatches === 1
          ? i18n.productOne
          : i18n.productOther;

      const countText =
        shownCount < totalMatches
          ? `${shownCount} / ${totalMatches} ${productLabel}`
          : `${totalMatches} ${productLabel}`;

      if (catalogLoading) {
        count.textContent = `${countText} · ${i18n.catalogLoading}`;
      } else {
        count.textContent = countText;
      }
      }
    }

    function buildSectionPageUrl(pageUrl, pageNumber) {
      const fallbackUrl = new URL(window.location.href);
      fallbackUrl.searchParams.delete('section_id');
      fallbackUrl.searchParams.set(pageParam, String(pageNumber));

      const url = pageUrl
        ? new URL(pageUrl, window.location.origin)
        : fallbackUrl;

      url.searchParams.set(pageParam, String(pageNumber));
      if (sectionId) {
        url.searchParams.set('section_id', sectionId);
      }
      return url.toString();
    }

    function appendCatalogPage(html) {
      if (!grid) return 0;

      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const fetchedRoot = documentFragment.querySelector('[data-ks-root]');
      const fetchedGrid = fetchedRoot?.querySelector('[data-ks-products-grid]');

      if (!fetchedRoot || !fetchedGrid) {
        throw new Error('The next catalog page could not be read.');
      }

      let added = 0;
      const fragment = document.createDocumentFragment();

      fetchedGrid.querySelectorAll('[data-ks-product-card]').forEach((card) => {
        const productId = String(card.dataset.ksProductId || '').trim();
        if (productId && knownProductIds.has(productId)) return;

        if (productId) knownProductIds.add(productId);
        card.hidden = true;
        cards.push(card);
        indexCard(card);
        fragment.appendChild(card);
        added += 1;
      });

      grid.appendChild(fragment);
      currentPage = Math.max(
        currentPage,
        Number.parseInt(fetchedRoot.dataset.ksCurrentPage || String(currentPage + 1), 10)
      );
      nextPageUrl = String(fetchedRoot.dataset.ksNextPageUrl || '').trim();
      return added;
    }

    async function loadRemainingCatalogPages() {
      if (catalogLoadPromise || (!nextPageUrl && currentPage >= totalPages) || !sectionId || !grid) {
        return catalogLoadPromise;
      }

      catalogLoadPromise = (async () => {
        catalogLoading = true;
        catalogLoadFailed = false;
        update();

        while ((nextPageUrl || currentPage < totalPages) && !destroyed) {
          const requestedPage = currentPage + 1;
          const response = await fetch(buildSectionPageUrl(nextPageUrl, requestedPage), {
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            },
            signal: catalogAbortController?.signal
          });

          if (!response.ok) {
            throw new Error(`Catalog page request failed with status ${response.status}.`);
          }

          const html = await response.text();
          const previousPage = currentPage;
          appendCatalogPage(html);
          if (currentPage <= previousPage) {
            currentPage = requestedPage;
          }
          // Während des Nachladens keine komplette Navigation nach jeder Seite
          // neu zählen. Das war bei großen Katalogen der größte Bremsfaktor.
          const now = window.performance?.now?.() || Date.now();
          if (hasActiveFilter() && now - lastCatalogProgressUpdate >= 350) {
            lastCatalogProgressUpdate = now;
            update();
            scheduleLazyCheck();
          }

          // Dem Browser zwischen zwei Katalogseiten Zeit für Eingaben und Darstellung geben.
          await yieldToBrowser();
        }

        if (destroyed) return;

        catalogLoading = false;

        if (grid.dataset.ksRandomOrder === 'true') {
          shuffleGrid(grid);
          cards.splice(
            0,
            cards.length,
            ...Array.from(grid.querySelectorAll('[data-ks-product-card]'))
          );
        }

        updateAvailableCounts();
        update();
        scheduleLazyCheck();
      })().catch((error) => {
        if (error?.name === 'AbortError') return;
        catalogLoading = false;
        catalogLoadFailed = true;
        update();
        showStatus(root, i18n.catalogLoadError, true);
        console.error('[KennzeichenShop] Catalog pagination failed:', error);
      });

      return catalogLoadPromise;
    }

    function update() {
      updateNavigationSearch();

      currentMatchingCards = cards.filter((card) => {
        return cardMatches(card);
      });

      const cardsToShow = currentMatchingCards.slice(
        0,
        visibleLimit
      );

      const visibleSet = new Set(cardsToShow);

      cards.forEach((card) => {
        card.hidden = !visibleSet.has(card);
      });

      const totalMatches = currentMatchingCards.length;
      const shownCount = cardsToShow.length;

      if (empty) {
        // Solange weitere Katalogseiten geladen werden, noch keine falsche
        // „Keine Treffer“-Meldung anzeigen.
        empty.hidden = totalMatches > 0 || catalogLoading;
      }

      if (grid) {
        grid.setAttribute('aria-busy', String(catalogLoading));
      }

      if (lazySentinel) {
        lazySentinel.hidden = shownCount >= totalMatches;
      }

      resetButtons.forEach((button) => {
        button.hidden = !hasActiveFilter();
      });

      updateActiveNavigation();
      updateHeading(totalMatches, shownCount);
    }

    function scrollToProducts() {
      productsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      closeHeaderSearch();
    }

    function setQuery(value, shouldScroll = false) {
      window.clearTimeout(queryTimer);
      const raw = String(value || '').trim();

      filters.query = normalize(raw);
      filters.country = '';
      filters.state = '';
      filters.vehicle = '';
      filters.special = '';
      filters.label = raw;

      visibleLimit = initialVisible;

      update();

      if (shouldScroll && raw) {
        scrollToProducts();
      }
    }

    function queueQuery(value) {
      window.clearTimeout(queryTimer);
      queryTimer = window.setTimeout(() => {
        setQuery(value);
      }, 140);
    }

    function setFilter(link, shouldScroll = true) {
      const country = String(link.dataset.ksFilterCountry || '').trim();
      const state = String(link.dataset.ksFilterState || '').trim();
      const vehicle = String(link.dataset.ksFilterVehicle || '').trim();
      const special = String(link.dataset.ksFilterSpecial || '').trim();
      const label = String(link.dataset.ksFilterLabel || state || country || vehicle || special).trim();
      const entry = link.closest('[data-ks-nav-entry]');
      const group = link.closest('[data-ks-nav-group]');

      if (entry?.hasAttribute('data-ks-nav-collapsible') && group) {
        group.dataset.ksNavExpanded = 'true';
      }

      filters.query = '';
      filters.label = label;

      if (vehicle) {
        filters.country = '';
        filters.state = '';
        filters.vehicle = vehicle;
        filters.special = '';
      } else if (special) {
        filters.country = country;
        filters.state = '';
        filters.vehicle = '';
        filters.special = special;
      } else {
        filters.country = country;
        filters.state = state;
        filters.vehicle = '';
        filters.special = '';
      }

      syncSearchInputs(label);

      visibleLimit = initialVisible;

      update();

      if (shouldScroll) {
        scrollToProducts();
      }
    }

    function reset(shouldScroll = false) {
      filters.query = '';
      filters.country = '';
      filters.state = '';
      filters.vehicle = '';
      filters.special = '';
      filters.label = '';

      visibleLimit = initialVisible;

      syncSearchInputs('');
      update();

      if (shouldScroll) {
        scrollToProducts();
      }
    }

    function toggleGroup(button) {
      const group = button.closest('[data-ks-nav-group]');
      if (!group) return;

      const expanded = group.dataset.ksNavExpanded === 'true';
      group.dataset.ksNavExpanded = String(!expanded);
      updateNavigationSearch();
    }

    function findExactEntry(value) {
      const wanted = normalize(value);
      if (!wanted) return null;

      const wantedVehicle = canonicalVehicle(wanted);
      const vehicleLink = filterLinks.find((link) => {
        const vehicle = link.dataset.ksFilterVehicle;
        return vehicle && canonicalVehicle(vehicle) === wantedVehicle;
      });
      if (vehicleLink) return vehicleLink;

      const specialLink = filterLinks.find((link) => {
        const special = link.dataset.ksFilterSpecial;
        return special && special !== '*' && canonicalSpecial(special) === canonicalSpecial(wanted);
      });
      if (specialLink) return specialLink;

      const entry = entries.find((item) => normalize(item.dataset.ksNavValue) === wanted);
      if (entry) return entry.querySelector('[data-ks-filter-link]');

      const wantedCountry = canonicalCountry(wanted);
      return filterLinks.find((link) => {
        const country = link.dataset.ksFilterCountry;
        const state = link.dataset.ksFilterState;
        const label = link.dataset.ksFilterLabel;
        return (
          (country && !state && canonicalCountry(country) === wantedCountry)
          || (state && normalize(state) === wanted)
          || (label && normalize(label) === wanted)
        );
      }) || null;
    }

    updateAvailableCounts();
    update();

    let lazyCheckFrame = 0;
    let lazyLoadLocked = false;

    function hasMoreMatchingCards() {
      return visibleLimit < currentMatchingCards.length;
    }

    function loadNextLazyBatch() {
      if (
        !lazySentinel ||
        !hasMoreMatchingCards() ||
        lazyLoadLocked
      ) {
        return;
      }

      lazyLoadLocked = true;

      /*
      * Immer nur einen Stapel laden:
      * 10 → 20 → 30 → 40
      */
      visibleLimit = Math.min(
        visibleLimit + lazyBatchSize,
        currentMatchingCards.length
      );

      update();

      if (!hasMoreMatchingCards()) {
        lazySentinel.hidden = true;
      }

      /*
      * Verhindert mehrfaches Nachladen durch
      * mehrere Scroll-Events hintereinander.
      */
      window.setTimeout(() => {
        lazyLoadLocked = false;
      }, 250);
    }

    function checkLazyPosition() {
      lazyCheckFrame = 0;

      if (
        !lazySentinel ||
        lazySentinel.hidden ||
        !hasMoreMatchingCards() ||
        lazyLoadLocked
      ) {
        return;
      }

      const rect = lazySentinel.getBoundingClientRect();

      const viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;

      /*
      * Erst laden, wenn der Benutzer fast am
      * Ende der sichtbaren Produkte angekommen ist.
      */
      const sentinelIsNear =
        rect.top <= viewportHeight + 150 &&
        rect.bottom >= -50;

      if (sentinelIsNear) {
        loadNextLazyBatch();
      }
    }

    function scheduleLazyCheck() {
      if (lazyCheckFrame) {
        return;
      }

      lazyCheckFrame =
        window.requestAnimationFrame(checkLazyPosition);
    }

    /*
    * Findet auch Scroll-Container innerhalb des Themes.
    */
    function getScrollTargets(element) {
      const targets = [window];
      let parent = element?.parentElement;

      while (
        parent &&
        parent !== document.body &&
        parent !== document.documentElement
      ) {
        const styles = window.getComputedStyle(parent);
        const overflowY = styles.overflowY;

        if (
          overflowY === 'auto' ||
          overflowY === 'scroll' ||
          overflowY === 'overlay'
        ) {
          targets.push(parent);
        }

        parent = parent.parentElement;
      }

      return [...new Set(targets)];
    }

    const lazyScrollTargets = lazySentinel
      ? getScrollTargets(lazySentinel)
      : [window];

    if (!lazySentinel) {
      console.error(
        '[KennzeichenShop] Lazy-Sentinel wurde nicht gefunden.'
      );
    } else {
      lazySentinel.hidden = cards.length <= initialVisible && !catalogLoading;
      lazySentinel.style.display = 'block';
      lazySentinel.style.width = '100%';
      lazySentinel.style.height = '40px';

      lazyScrollTargets.forEach((target) => {
        target.addEventListener(
          'scroll',
          scheduleLazyCheck,
          { passive: true }
        );
      });

      window.addEventListener(
        'resize',
        scheduleLazyCheck,
        { passive: true }
      );
    }

    // Shopify Liquid returns at most 250 products per page. Load every
    // following page through the Section Rendering API and merge the cards.
    const startBackgroundCatalogLoad = () => {
      loadRemainingCatalogPages();
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(startBackgroundCatalogLoad, { timeout: 600 });
    } else {
      window.setTimeout(startBackgroundCatalogLoad, 180);
    }

    return {
      setQuery,
      queueQuery,
      setFilter,
      reset,
      toggleGroup,
      findExactEntry,
      scrollToProducts,
      destroy() {
        destroyed = true;
        window.clearTimeout(queryTimer);
        catalogAbortController?.abort();

        if (lazyCheckFrame) {
          window.cancelAnimationFrame(lazyCheckFrame);
        }

        lazyScrollTargets.forEach((target) => {
          target.removeEventListener(
            'scroll',
            scheduleLazyCheck
          );
        });

        window.removeEventListener(
          'resize',
          scheduleLazyCheck
        );
      }
    };
  }

  function bindGlobalEvents() {
    if (registry.eventsBound) return;
    registry.eventsBound = true;

    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-ks-catalog-search]');
      if (!input) return;
      const root = document.querySelector(SELECTOR);
      const controller = root && registry.controllers.get(root);
      if (!controller) return;
      syncSearchInputs(input.value);
      controller.queueQuery(input.value);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-ks-catalog-search-form]');
      if (!form) return;
      const root = document.querySelector(SELECTOR);
      const controller = root && registry.controllers.get(root);
      if (!controller) return;

      const input = form.querySelector('[data-ks-catalog-search]') || document.querySelector('[data-ks-catalog-search]');
      const value = input?.value?.trim() || '';
      if (!value) return;

      event.preventDefault();
      const exactLink = controller.findExactEntry(value);
      if (exactLink) controller.setFilter(exactLink);
      else {
        controller.setQuery(value, true);
        syncSearchInputs(value);
      }
    });

    document.addEventListener('click', (event) => {
      const navToggle = event.target.closest('[data-ks-nav-toggle]');
      if (navToggle) {
        const root = navToggle.closest(SELECTOR) || document.querySelector(SELECTOR);
        const controller = root && registry.controllers.get(root);
        if (!controller) return;
        event.preventDefault();
        controller.toggleGroup(navToggle);
        return;
      }

      const reset = event.target.closest('[data-ks-filter-reset]');
      if (reset) {
        const root = reset.closest(SELECTOR) || document.querySelector(SELECTOR);
        const controller = root && registry.controllers.get(root);
        if (!controller) return;
        event.preventDefault();
        controller.reset(reset.closest('.ks-products') !== null);
        return;
      }

      const link = event.target.closest('[data-ks-filter-link]');
      if (!link) return;
      const root = link.closest(SELECTOR) || document.querySelector(SELECTOR);
      const controller = root && registry.controllers.get(root);
      if (!controller) return;
      event.preventDefault();
      controller.setFilter(link);
    });
  }

  function initShop(root) {
    if (root.dataset.ksInitialized === 'true') return;
    root.dataset.ksInitialized = 'true';

    shuffleGrid(root.querySelector('[data-ks-random-order]'));

    // Beim ersten Aufruf der Startseite sind alle Länder- und Spezialfilter geschlossen.
    root.querySelectorAll('[data-ks-nav-group] details').forEach((details) => {
      details.open = false;
    });

    const controller = createCatalogController(root);
    registry.controllers.set(root, controller);

    const initialSearch = new URLSearchParams(window.location.search).get('ks_q');
    if (initialSearch) {
      syncSearchInputs(initialSearch);
      const exactLink = controller.findExactEntry(initialSearch);
      if (exactLink) controller.setFilter(exactLink, false);
      else controller.setQuery(initialSearch, false);
    }

    const drawer = root.querySelector('[data-ks-drawer]');
    const openButton = root.querySelector('[data-ks-open]');
    const closeButton = root.querySelector('[data-ks-close]');
    const overlay = root.querySelector('[data-ks-overlay]');
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    let lastFocusedElement = null;

    root.addEventListener('submit', (event) => quickAdd(event, root));


    if (!drawer || !openButton || !overlay) return;

    function setState(isOpen) {
      root.classList.toggle('is-drawer-open', isOpen);
      document.body.classList.toggle('ks-drawer-open', isOpen);
      openButton.setAttribute('aria-expanded', String(isOpen));
      overlay.tabIndex = isOpen ? 0 : -1;

      if (isOpen) {
        lastFocusedElement = document.activeElement;
        getFocusable(drawer)[0]?.focus();
      } else if (lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus();
      }
    }

    function open() { if (mediaQuery.matches) setState(true); }
    function close() { setState(false); }

    openButton.addEventListener('click', open);
    overlay.addEventListener('click', close);
    closeButton?.addEventListener('click', close);

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = getFocusable(drawer);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    mediaQuery.addEventListener?.('change', (event) => { if (!event.matches) close(); });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initShop);
  }

  bindGlobalEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((root) => {
      const controller = registry.controllers.get(root);
      controller?.destroy?.();
      registry.controllers.delete(root);
    });
  });
})();
